export enum VaultCardId {
  YOUR_DESPOITS = 'YOUR_DESPOITS',
  VAULT = 'VAULT',
}
export const ALL_TIME_EARNED_SHOW_LIMIT = 100000;
